import React, { FC, useEffect, useMemo, useState } from 'react'
import { motion } from 'framer-motion'
import { Bubble, Help } from './styled'
import { startHelpAnimation } from 'utils'

type Props = {
  isHelpDone: boolean
  makeHelpDone: () => void
  helpData: Array<{
    bubbleOpacity: number
    className: string
    message: string
  }>
}

export const HelpAnimation: FC<Props> = ({ isHelpDone, makeHelpDone, helpData }) => {
  const initState = useMemo(() => helpData.map(e => e.bubbleOpacity), [helpData]);
  const [bubbleOpacity, setBubbleOpacity] = useState(initState)

  useEffect(() => {
    startHelpAnimation(bubbleOpacity, setBubbleOpacity, makeHelpDone)
  }, [])

  return (
    <Help isActive={!isHelpDone}>
      {
        helpData.map((e, i) => {
          return (
            <motion.div
            style={{ opacity: 0 }}
            animate={{ opacity: bubbleOpacity[i] }}
            key={e.className}
          >
            <Bubble className={e.className}>{e.message}
              <svg viewBox='0 0 10 10'>
                <path d='M0 0,10 0, 5 10' />
              </svg>
            </Bubble>
          </motion.div>
          )
        })
      }
    </Help>
  )
}
